
export function menuBtnHover(element) {
  element.addEventListener('mousemove', () => element.classList.add('show'));
  element.addEventListener('mouseout', () => element.classList.remove('show'));
  Array.from(element.querySelectorAll('#myaccount-dropdown-close')).forEach((ddCloseBtn) => {
    ddCloseBtn.addEventListener('click', () => {
      element.classList.remove('show');
    });
  });
}